import { render, staticRenderFns } from "./exceptPage.vue?vue&type=template&id=dbb305c8"
import script from "./exceptPage.vue?vue&type=script&lang=js"
export * from "./exceptPage.vue?vue&type=script&lang=js"
import style0 from "./exceptPage.vue?vue&type=style&index=0&id=dbb305c8&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports